import { csrfToken } from 'rails-ujs';

$(() => {
  //▼ コンテンツお気に入り登録・解除
  $('a.favorite_content').on('click', function () {
    var favorite = $(this);
    var wrap_div = favorite.parent("div");
    var content_id = favorite.data("content-id");
    var ballon = $("div.ballon-box");
    var tooltip = ballon.children("div.arrow_box");

    $.ajax({
      type: 'POST',
      url: '/api/favorite_contents/refresh',
      headers: {
        'X-CSRF-Token': csrfToken()
      },
      data: {
        "content_id": content_id
      }
    }).done(function () {
      if (wrap_div.hasClass("btn-fav-off")) {
        wrap_div.removeClass("btn-fav-off").addClass("btn-fav");
        tooltip.text("お気に入りに登録しました");
      } else {
        wrap_div.removeClass("btn-fav").addClass("btn-fav-off");
        tooltip.text("お気に入りを解除しました");
      }
      ballon.show();
      setTimeout(function () {
        ballon.hide();
      }, 2000);
    });
  });
});
